var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enrolling-exam-write-pass-student"},[_c('PlatDataGridSiteUnit',{attrs:{"grid-id":"PeEnrollExamWritePassStudent","show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }